// Components/BusinessItemRow.jsx
import React from "react";

const fmtYMD = (v) => {
  if (!v) return "-";
  if (typeof v === "string") return v.slice(0, 10).replace(/-/g, ".");
  const d = new Date(v); if (isNaN(d)) return "-";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}.${mm}.${dd}`;
};

const StatusPill = ({ status }) => {
  const map = {
    pending: { label: "대기", bg: "#7864F91A", color: "#7864F9" },
    approved: { label: "승인", bg: "#F6F6F6", color: "#0000004D" },
    rejected: { label: "반려", bg: "#F964661A", color: "#F96466" },
  };
  const s = map[status] || { label: status ?? "-", bg: "#EEE", color: "#666" };
  return (
    <span
      className="inline-flex items-center px-3 h-7 rounded-full text-xs font-medium whitespace-nowrap"
      style={{ backgroundColor: s.bg, color: s.color }}
    >
      {s.label}
    </span>
  );
};

const thBase =
  "px-4 py-3 text-xs font-semibold text-gray-600 bg-gray-50 border-b border-gray-200 align-middle whitespace-nowrap";
const tdBase =
  "px-4 py-3 text-sm text-gray-800 border-t border-gray-200 align-middle";

export default function BusinessItemRow({
  items = [],
  apiBase,
  onApprove,
  onReject,
  actionLoading = false,
  className = "",
}) {
  return (
    <div className={`mt-2 overflow-x-auto ${className}`}>
      <table className="w-full table-auto border border-gray-200 rounded-xl overflow-hidden">
        <colgroup>
          <col style={{ width: 80 }} />      {/* 제출 상태 */}
          <col />                             {/* 사업주 (가변) */}
          <col style={{ width: 170 }} />      {/* 사업자번호 */}
          <col style={{ width: 120 }} />      {/* 등록 일자 */}
          <col style={{ width: 120 }} />      {/* 확인 일자 */}
          <col style={{ width: 90 }} />       {/* 첨부 */}
          <col />                             {/* 상태 메모 (가변) */}
          <col style={{ width: 160 }} />      {/* 액션 */}
        </colgroup>

        <thead>
          <tr>
            <th className={`${thBase} text-center`}>제출 상태</th>
            <th className={thBase}>사업주</th>
            <th className={`${thBase} whitespace-nowrap text-center`}>사업자 등록번호</th>
            <th className={`${thBase} text-center`}>등록 일자</th>
            <th className={`${thBase} text-center`}>확인 일자</th>
            <th className={`${thBase} text-center`}>첨부</th>
            <th className={thBase}>상태</th>
            <th className={`${thBase} text-center`}>-</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => {
            const raw = item?.saved_path || "";
            const normalized = raw.replace(/\\/g, "/");
            const webPath = normalized.replace(/^app\//i, "");
            const fileUrl = apiBase ? `${apiBase}/${encodeURI(webPath)}` : "";
            const isPending = item?.status === "pending";
            const disabled = actionLoading || !isPending;

            return (
              <tr key={item.id}>
                <td className={`${tdBase} text-center`}>
                  <StatusPill status={item?.status} />
                </td>

                <td className={`${tdBase} text-center`}>
                  {item?.business_name || "-"}
                </td>

                <td className={`${tdBase} font-mono whitespace-nowrap text-center`}>
                  {item?.business_number || "-"}
                </td>

                <td className={`${tdBase} text-center whitespace-nowrap`}>
                  {fmtYMD(item?.created_at)}
                </td>

                <td className={`${tdBase} text-center whitespace-nowrap`}>
                  {fmtYMD(item?.reviewed_at)}
                </td>

                <td className={`${tdBase} text-center`}>
                  {fileUrl ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center px-3 h-7 rounded-full text-xs bg-gray-100 text-gray-700 border border-gray-200"
                    >
                      확인
                    </a>
                  ) : (
                    <span className="inline-flex items-center px-3 h-7 rounded-full text-xs bg-gray-100 text-gray-500 border border-gray-200">
                      없음
                    </span>
                  )}
                </td>

                <td className={`${tdBase} break-words text-center`}>
                  {item?.notes || "-"}
                </td>

                <td className={`${tdBase} text-right whitespace-nowrap`}>
                  {isPending ? (
                    <span className="inline-flex gap-2">
                      <button
                        onClick={() => !disabled && onApprove?.(item.id)}
                        disabled={disabled}
                        className="text-xs px-3 h-8 rounded border text-green-700 border-green-300 hover:bg-green-600 hover:text-white disabled:opacity-50"
                      >
                        {actionLoading ? "처리중..." : "승인"}
                      </button>
                      <button
                        onClick={() => !disabled && onReject?.(item)}
                        disabled={disabled}
                        className="text-xs px-3 h-8 rounded border text-red-700 border-red-300 hover:bg-red-600 hover:text-white disabled:opacity-50"
                      >
                        반려
                      </button>
                    </span>
                  ) : (
                    <span className="text-xs text-gray-400">-</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
